module.exports = __webpack_public_path__ + "img/pug.39702f7c.png";